module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "showClose": false,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "employment-rates",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "employment-rates__header"
  }, [_c('h2', [_vm._v("Ansættelsesgrader"), (_vm.schoolYearName) ? _c('span', [_vm._v(" " + _vm._s(_vm.schoolYearName))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle doc-modal__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "employment-rates__body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "do-spinner__container"
  }, [_c('div', {
    staticClass: "do-spinner do-spinner--large"
  })]) : _c('table', {
    staticClass: "do-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "is-clickable",
    on: {
      "click": function($event) {
        return _vm.setSort('name')
      }
    }
  }, [_vm._v("\n            Navn\n            "), (_vm.sort.key === 'name') ? _c('span', [_vm._v(_vm._s(_vm.sort.dir === 'asc' ? '▲' : '▼'))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.columns), function(col) {
    return _c('th', {
      key: 'h-' + col,
      staticClass: "is-clickable",
      on: {
        "click": function($event) {
          return _vm.setSort(col)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.columnLabel(col)) + "\n            "), (_vm.sort.key === col) ? _c('span', [_vm._v(_vm._s(_vm.sort.dir === 'asc' ? '▲' : '▼'))]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.displayedRows), function(row) {
    return _c('tr', {
      key: row.id
    }, [_c('td', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _vm._l((_vm.columns), function(col) {
      return _c('td', {
        key: 'c-' + row.id + '-' + col
      }, [_vm._v("\n            " + _vm._s(row.values[col]) + "\n          ")])
    })], 2)
  }), _vm._v(" "), (!_vm.displayedRows.length) ? _c('tr', [_c('td', {
    staticClass: "employment-rates__empty",
    attrs: {
      "colspan": _vm.columns.length + 1
    }
  }, [_vm._v("\n            Ingen data for det valgte skoleår\n          ")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "employment-rates__footer"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Luk")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isDownloading
    },
    attrs: {
      "disabled": _vm.isLoading || !_vm.displayedRows.length
    },
    on: {
      "click": _vm.asyncLoadXLSXAndDownload
    }
  }, [_vm._v("\n        Download til Excel\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ee5674d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssignHours/AssignHoursEmploymentRates.vue
// module id = 1794
// module chunks = 1